export default __webpack_public_path__ + "static/media/stackdriver.cf8c3224.svg";